/**
 * "Value moment" signal for the push permission ask (TD-003): the
 * EnableNotificationsCard renders only after the client has completed an
 * approval action. The flag lives in sessionStorage (per-tab, survives
 * reloads); the custom event makes same-render-tree listeners reactive,
 * since a child-route mutation does not re-render ApprovalView by itself.
 */

const FLAG_KEY = "touchpoint_portal_did_approve";
const EVENT_NAME = "touchpoint:portal-approved";

export function markPortalApproval(): void {
  try {
    sessionStorage.setItem(FLAG_KEY, "1");
    window.dispatchEvent(new CustomEvent(EVENT_NAME));
  } catch {
    // Storage unavailable (private mode edge cases) — the card just
    // won't show; approving must never throw over this.
  }
}

export function hasPortalApproval(): boolean {
  try {
    return sessionStorage.getItem(FLAG_KEY) === "1";
  } catch {
    return false;
  }
}

export function onPortalApproval(callback: () => void): () => void {
  window.addEventListener(EVENT_NAME, callback);
  return () => window.removeEventListener(EVENT_NAME, callback);
}
